<script lang="ts">
    import {Row} from "svelte-layouts";
    import Button from "@smui/button";
    import Menu from "@smui/menu";
    import List from "@smui/list";
    import {onMount} from "svelte";
    import {getCurrentUser, logout, onLogin, setOpenAuth} from "../api/user";
    import {Divider} from "svelte-materialify";
    import AccountMenuButton from "./AccountMenuButton.svelte";
    import Auth from "./Auth.svelte";
    import LinearProgress from "@smui/linear-progress";
    import Settings from "./Settings.svelte";
    import MyAccount from "./MyAccount.svelte";
    import Dialog from "@smui/dialog";
    import {Content, Title} from "@smui/paper";
    import {Row} from "svelte-layouts";
    import HackerPlsNoOpen from "./HackerPlsNoOpen.svelte"
    import Snack from "./Snack.svelte";
    import Input from "./Input.svelte";

    let menu
    let anchor: HTMLDivElement;
    let anchorClasses: { [k: string]: boolean } = {};
    let user

    let openAuth = false
    let openSettings = false
    let openMyAccount = false
    let loading = false
    let signInLoading = false
    let openLoginMenu = false
    let inviteMessage = false
    let email = ''

    function truncate(str, n){
        return (str.length > n) ? str.substring(0, n-1) + '..' : str;
    }

    const handleLogout = async () => {
        if (loading)
            return

        loading = true

        try {
            await logout()
            user = null
            window.location = '/'
        } catch (e) {
            console.log(e)
        }

        loading = false
    }

    let openDebugMenu = false


    onMount(() => {
        // setOpenAuth(() => openAuth = true)
        // onLogin(() => {
        //     user = getCurrentUser()
        // })
    })

    function clearLocalStorage(){
        window.localStorage.removeItem("layout3")
        window.localStorage.removeItem("filters")
        window.localStorage.removeItem("cargo-selectedColumns")
        window.localStorage.removeItem("selectedFilters")
        window.localStorage.removeItem("datToken")
        window.localStorage.removeItem("datTokenDate")
    }

    function signIn() {
        signInLoading = true
        setTimeout(() => {
            signInLoading = false
            inviteMessage = true
        }, 3000)
    }
</script>

<div style="background: #FFFFFF">
    <Row style={{height:"50px",margin:"0px"}}>
        <div style="font-family: 'Source Sans Pro'; font-style: normal; font-weight: 600; font-size: 20px;
        line-height: 25px; display: flex; align-items: center; color: #0043A4; margin-left: 30px">
            Loder
        </div>
        <Dialog bind:open={openDebugMenu}>
            <Title>Debug Menu</Title>
            <Content>
                <Button on:click={() => {clearLocalStorage()}}>Clear LocalStorage</Button>
                <HackerPlsNoOpen/>
            </Content>
        </Dialog>
        <Snack/>
        <Row>
            <!--{#if loggedIn && loggedIn.canOpenDebugMenu}-->
<!--            <Button on:click={() => {openDebugMenu = true; console.log(openDebugMenu)}}>     </Button>-->
            <!--{/if}-->
        </Row>
        <div style="flex: 1"></div>
        {#if user}
<!--            <IconButton style="width: 34px; height: 34px; background: #FAFAFA; margin-top: auto; margin-bottom: auto;-->
<!--                            border-radius: 5px;" on:click={() => {}}>-->
<!--                <img style="width: 24px; height: 24px; text-align: center;" src="assets/svg/widget_add.svg" alt="Add Widget" />-->
<!--            </IconButton>-->
<!--            <div style="border-left: 1px solid #F2F4F7; height:32px; margin: auto 20px;"></div>-->
            <!--        <a href="#" style="text-decoration: underline; color: #0043A4; font-family: 'Source Sans Pro'; font-style: normal;-->
            <!--         font-weight: 400; font-size: 16px; line-height: 20px; display: flex; align-items: center; margin-right: 10px">-->
            <!--            Tutorial-->
            <!--        </a>-->
<!--            <IconButton style="width: 34px; height: 34px; background: #FAFAFA; margin-top: auto; margin-bottom: auto;-->
<!--                            border-radius: 5px; margin-right: 10px" on:click={() => {}}>-->
<!--                <img style="width: 24px; height: 24px; text-align: center;" src="assets/svg/bell.svg" alt="Notifications" />-->
<!--            </IconButton>-->
<!--            <IconButton style="width: 34px; height: 34px; background: #FAFAFA; margin-top: auto; margin-bottom: auto;-->
<!--                            border-radius: 5px; margin-right: 10px" on:click={() => {}}>-->
<!--                <img style="width: 24px; height: 24px; text-align: center;" src="assets/svg/message.svg" alt="Messages" />-->
<!--            </IconButton>-->
            <div bind:this={anchor} style="margin-top: auto; margin-bottom: auto; margin-right: 30px; height: 34px">
                <Button style="width: 119px; height: 34px; background: #FAFAFA;
                            border-radius: 5px; text-transform: none" on:click={() => menu.setOpen(true)}>
                    <img style="width: 24px; height: 24px; text-align: center;" src="assets/svg/user.svg" alt="Account" />
                    <div style="font-family: 'Source Sans Pro'; font-style: normal; font-weight: 600; font-size: 16px;
                        line-height: 20px; display: flex; align-items: center; color: #B2B6CC; margin-left: 10px;
                        margin-right: 10px;">
                        {truncate(user.firstName, 7)}
                    </div>
                </Button>
                <Menu style="width: 220px; left: -71px" bind:this={menu} bind:anchorElement={anchor} anchorCorner="BOTTOM_LEFT">
                    <List>
                        <AccountMenuButton on:accountMenuClick={() => {openMyAccount = true; menu.setOpen(false)}} svg="settings" text="Settings" marginBottom={20} marginTop={20}/>
<!--                        <AccountMenuButton on:accountMenuClick={() => {openSettings = true; menu.setOpen(false)}} svg="settings" text="Settings" marginBottom={15}/>-->
                        <Divider style="color: #F3F3F3; margin-bottom: 15px"/>
                        <AccountMenuButton on:accountMenuClick={handleLogout} svg="sign-out" text="Sign out" marginBottom={20}/>
                    </List>
                </Menu>
            </div>
        {:else}
            <div style="margin-top: auto; margin-bottom: auto; margin-right: 30px; height: 34px">
                <Button style="width: 200px; height: 34px; background: #FAFAFA; border-radius: 5px; text-transform: none" on:click={() => openLoginMenu = true}>
                    <div style="font-family: 'Source Sans Pro'; font-style: normal; font-weight: 600; font-size: 16px;
                            line-height: 20px; display: flex; align-items: center; color: #B2B6CC; margin-left: 10px;
                            margin-right: 10px;">
                        SIGN IN / SIGN UP
                    </div>
                </Button>
            </div>
        {/if}
    </Row>
    {#if (loading)}
        <LinearProgress indeterminate/>
    {/if}
</div>

<Dialog bind:open={openLoginMenu} surface$style="width: 500px; padding: 16px;">
    <Title>
        <h3>Sign in</h3>
    </Title>
    <Content>
        <div style="margin: 20px 0; height: 30px;">
            {#if signInLoading}
                <LinearProgress indeterminate/>
            {:else if inviteMessage}
                Please reach out to the administrator and request an invitation in order to access and use our app!
            {:else}
                <Row justifyContent="space-between" alignItems="end">
                    <Input bind:value={email} label="Email" width="350px" height="30px"/>
                    <Button variant="unelevated"
                            style="border-radius: 600px; height: 30px; margin: 0;"
                            type="submit"
                            on:click={signIn}
                    >
                        Sign In
                    </Button>
                </Row>
            {/if}
        </div>
    </Content>
</Dialog>

<!--<Auth bind:open={openAuth}/>-->
<!--<Settings bind:open={openSettings}/>-->
<!--<MyAccount on:save={(e) => {user = e.detail}} bind:open={openMyAccount}/>-->